<template>
  <!-- 用户消息详情弹窗 -->
  <el-dialog
    v-model="messageDialogVisible"
    :title="messageDialogTitle"
    width="800px"
    :before-close="handleMessageDialogClose"
    class="message-dialog"
  >
    <div class="dialog-content">
      <div class="detail-section">
        <div class="detail-item">
          <div class="detail-label">公告名称：</div>
          <div class="detail-value">{{ messageDetailData.announcementName || messageDetailData.projectName || '未命名' }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">公告编号：</div>
          <div class="detail-value">{{ messageDetailData.announcementNo || '--' }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">转让标的：</div>
          <div class="detail-value">{{ messageDetailData.projectName || '--' }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">挂牌价：</div>
          <div class="detail-value">{{ formatPrice(messageDetailData.listingPrice) }}</div>
        </div>
        <div class="detail-item" v-if="messageDetailData.dealPrice">
          <div class="detail-label">成交价：</div>
          <div class="detail-value" style="color: #EF4444; font-weight: 600;">{{ formatPrice(messageDetailData.dealPrice) }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label">挂牌时间：</div>
          <div class="detail-value">{{ formatTime(messageDetailData.listingStartTime) }} 至 {{ formatTime(messageDetailData.listingEndTime) }}</div>
        </div>
        <div class="detail-item" v-if="messageDetailData.dealDate">
          <div class="detail-label">成交日期：</div>
          <div class="detail-value">{{ formatTime(messageDetailData.dealDate) }}</div>
        </div>
        <div class="detail-item" v-if="messageDetailData.transferorDeptName">
          <div class="detail-label">转让方：</div>
          <div class="detail-value">{{ messageDetailData.transferorDeptName }}</div>
        </div>
        <div class="detail-item" v-if="messageDetailData.transfereeDeptName">
          <div class="detail-label">受让方：</div>
          <div class="detail-value">{{ messageDetailData.transfereeDeptName }}</div>
        </div>
        <div class="detail-item" v-if="messageDetailData.remark">
          <div class="detail-label">备注：</div>
          <div class="detail-value">{{ messageDetailData.remark }}</div>
        </div>
      </div>
    </div>
  </el-dialog>

    <!-- 顶部横幅 -->
    <div class="banner-section">
      <img src="../assets/img/jydt/jydt.png" alt="" class="banner-image">
      <div class="banner-overlay">
        <div class="banner-text-wrapper">
<!--          <p class="banner-subtitle">TECHNOLOGY TRANSFORMATION</p>-->
          <h1 class="banner-title">交易大厅</h1>
        </div>
      </div>
    </div>

    <!-- 交易大厅区域 -->
    <div class="trading-section">
      <div class="content-container">
        <div class="main-layout">
        <!-- 左侧：成交公告 -->
        <div class="left-section">
          <div class="section-header">
            <img src="../assets/img/jydt/Container1.png" alt="" style="width: 20px; height: 20px;">
            <h3 class="section-title">成交公告</h3>
          </div>
          
          <div v-loading="loading" class="messages-list">
            <div v-if="dealAnnouncementList.length === 0" class="no-data-small">暂无成交公告</div>
            
            <div 
              v-for="item in dealAnnouncementList" 
              :key="item.id" 
              class="message-item"
              @click="handleAnnouncementClick(item)"
            >
              <div class="message-dot"></div>
              <div class="message-content">
                <h4 class="message-title">{{ item.announcementName || item.projectName || '未命名公告' }}</h4>
                <div class="message-meta">
                  <span class="message-date">{{ item.dealDate ? item.dealDate.slice(0, 10) : (item.createTime ? item.createTime.slice(0, 10) : '--') }}</span>
                  <span class="message-time">{{ item.dealDate ? item.dealDate.slice(11, 19) : (item.createTime ? item.createTime.slice(11, 19) : '--') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧：服务模块 -->
        <div class="right-section">
          <a href="http://39.105.114.210:13307/login" target="_blank" class="service-module">
            <div class="module-icon">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect x="8" y="12" width="32" height="24" rx="2" stroke="#3B82F6" stroke-width="2"/>
                <path d="M16 20H32M16 26H24" stroke="#3B82F6" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
            <h3 class="module-title">交易登记</h3>
<!--            <p class="module-subtitle">Transaction Registration</p>-->
          </a>

          <a href="https://ctmht.chinatorch.org.cn/admin/login" target="_blank" class="service-module">
            <div class="module-icon">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect x="10" y="8" width="28" height="32" rx="2" stroke="#3B82F6" stroke-width="2"/>
                <path d="M18 16H30M18 22H26M18 28H30" stroke="#3B82F6" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
            <h3 class="module-title">技术合同登记</h3>
<!--            <p class="module-subtitle">Contract Registration</p>-->
          </a>
        </div>
      </div>

      <!-- 竞价会模块 -->
      <div class="auction-section">
        <div class="auction-header">
          <h2 class="announcement-title">竞价会</h2>
        </div>
        <div v-loading="auctionLoading" class="auction-table-wrapper">
          <el-table :data="auctionList" style="width:100%" :header-cell-style="{ background: '#F8FAFC', color: '#374151', fontWeight: '500' }">
            <el-table-column label="竞价名称" prop="projectName" show-overflow-tooltip min-width="200">
              <template #default="scope">
                <span style="color:#3B82F6;cursor:pointer;" @click="goToAuction(scope.row)">{{ scope.row.projectName || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="参竞人数" prop="bidderCount" align="center" width="100">
              <template #default="scope">{{ scope.row.bidderCount ?? '--' }}</template>
            </el-table-column>
            <el-table-column label="开始时间" prop="bidStartTime" align="center" min-width="160" show-overflow-tooltip>
              <template #default="scope">{{ scope.row.bidStartTime || '--' }}</template>
            </el-table-column>
            <el-table-column label="当前状态" prop="stageName" align="center" width="110">
              <template #default="scope">
                <el-tag size="small" :type="scope.row.stage === 'free' || scope.row.stage === 'limited' ? 'danger' : scope.row.stage === 'not_started' || scope.row.stage === 'preparation' ? 'warning' : 'info'" effect="plain">
                  {{ scope.row.stageName || '--' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="起拍价" prop="bidStartPrice" align="center" width="140">
              <template #default="scope">
                <span style="color:#EF4444;font-weight:600;">{{ scope.row.bidStartPrice != null ? Number(scope.row.bidStartPrice).toLocaleString() + ' 元' : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="当前价" prop="currentPrice" align="center" width="140">
              <template #default="scope">
                <span style="color:#EF4444;font-weight:600;">{{ scope.row.currentPrice != null ? Number(scope.row.currentPrice).toLocaleString() + ' 元' : '--' }}</span>
              </template>
            </el-table-column>
            <template #empty>
              <div style="text-align:center;padding:30px 0;color:#9CA3AF;">当前暂无竞价会</div>
            </template>
          </el-table>
        </div>
      </div>

      <!-- 项目公告区域 -->
      <div class="announcement-section">
        <div class="announcement-header">
          <h2 class="announcement-title">项目公告</h2>
        </div>

        <!-- 筛选区域 -->
        <div class="filter-section">
          <div class="filter-row">
            <span class="filter-label">项目分类：</span>
            <div class="filter-tags">
              <div 
                v-for="(item, index) in categoryList" 
                :key="index" 
                :class="['filter-tag', { 'filter-tag-active': category === item }]"
                @click="category = item"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div class="filter-row">
            <span class="filter-label">公告类型：</span>
            <div class="filter-tags">
              <div 
                v-for="(item, index) in typeList" 
                :key="index" 
                :class="['filter-tag', { 'filter-tag-active': type === item }]"
                @click="type = item"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div class="filter-row">
            <span class="filter-label">公告状态：</span>
            <div class="filter-tags">
              <div 
                v-for="(item, index) in statusList" 
                :key="index" 
                :class="['filter-tag', { 'filter-tag-active': status === item }]"
                @click="status = item"
              >
                {{ item }}
              </div>
            </div>
            <div class="search-box">
              <input 
                v-model="searchKeyword" 
                type="text" 
                placeholder="请输入关键词" 
                class="search-input"
                @keyup.enter="handleSearch"
              >
              <button class="search-btn" @click="handleSearch">开始搜索</button>
            </div>
          </div>
        </div>

        <!-- 项目卡片列表 -->
        <div v-loading="announcementLoading" class="projects-grid">
          <div v-if="announcementData.length === 0" class="no-data">
            暂无公告数据
          </div>
          
          <div 
            v-for="item in announcementData" 
            :key="'announcement-' + item.id" 
            class="project-card"
            @click="goToDetail(item)"
          >
            <div class="project-image">
              <img v-if="item.coverImage" :src="'/prod-api' + item.coverImage" alt="" style="width:100%;height:100%;object-fit:contain;">
              <img v-else src="../assets/img/q2.png" alt="" style="width:100%;height:100%;object-fit:contain;">
              <div class="project-badge">{{ getProjectTypeText(item.projectType) }}</div>
            </div>
            <div class="project-content">
              <h4 class="project-title">{{ item.projectName || '未命名项目' }}</h4>
              <div class="project-info">
                <div class="info-row">
                  <span class="info-label">挂牌价：</span>
                  <span style="color:#EF4444;font-weight:600;">{{ item.listingPrice ? item.listingPrice + ' ' + (item.listingPriceUnit || '元') : '--' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">报名截止时间：</span>
                  <span class="info-value">{{ item.applyEndTime || '--' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">竞标开始时间：</span>
                  <span class="info-value">{{ item.bidStartTime || '--' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div class="pagination-wrapper" v-if="announcementTotal > 0">
          <div class="pagination-left">
            <span class="pagination-info">共 {{ announcementTotal }} 条</span>
          </div>
          <el-pagination
            class="custom-pagination"
            :page-size="pageSize"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            layout="prev, pager, next"
            :total="announcementTotal"
          />
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  
  import { getAction } from '@/api/requests'
  import { getAnnouncementList, getProjectHallList } from '@/api/announcement'
  
  
  export default {
    name: 'jydtContent',
    components: {
  
     
    },
    props: {
      idsss: {
        type: String,
        default: '',
      },
      initialType: {
        type: String,
        default: '',
      }
    },
    data(){
      return{
        listnum:0,
        tableData:[],
        dealAnnouncementList: [], // 成交公告列表
        announcementData: [], // 项目公告数据
        announcementTotal: 0, // 公告总数
        announcementLoading: false, // 公告加载状态
        currentPage: 1, // 当前页码
        pageSize: 6, // 每页显示数量
        tablists:['全部','技术','专利','成果','其他'],
        tabis:'全部',
        loading:false,
        category: '全部',
        categoryList: ['全部', '转让', '许可', '作价入股', '开放许可'],
        type: '全部',
        typeList: ['全部', '正式挂牌', '意向挂牌'],
        status: '全部',
        statusList: ['全部', '挂牌中', '报名中', '竞价中', '已成交', '已终止'],
        searchKeyword: '', // 搜索关键词
        messageDialogVisible: false,
        messageDialogTitle: '公告详情',
        messageDetailData: {},
        auctionList: [
          {
            id: 1,
            auctionName: '智能制造生产线自动化升级改造技术竞价会',
            bidderCount: 3,
            startTime: '2026-06-09 10:00:00',
            status: 'free',
            startPrice: 500000,
            currentPrice: 500000
          }
        ],
        auctionLoading: false
      }
    },
    watch: {
      idsss:{
      handler(val) {
   
        console.log(val);
        this.getzjsjlist()
      }
    },
    category() {
      this.currentPage = 1
      this.getAnnouncementListData()
    },
    type() {
      this.currentPage = 1
      this.getAnnouncementListData()
    },
    status() {
      this.currentPage = 1
      this.getAnnouncementListData()
    }
    },
    mounted(){
      if (this.initialType) {
        this.type = this.initialType
      }
      this.getzjsjlist()
      this.getDealAnnouncementList()
      this.getAnnouncementListData()
      this.getAuctionList()
      this.injectMessageDialogStyles()
    },
    methods:{
      // 跳转到竞价详情
      goToAuction(item) {
        console.log('竞价项目数据:', JSON.stringify(item)) // 确认 applyId 字段
        this.$router.replace({ path: '/', query: { id: '9' } })
        this.$nextTick(() => {
          this.$router.push({ path: '/auction-detail', query: { id: item.projectId, applyId: item.applyId } })
        })
      },
      // 获取竞价会列表
      getAuctionList() {
        this.auctionLoading = true
        getAction('/trade/project_apply/bid_session/list').then(res => {
          const rows = res.rows || res.data || []
          if (rows.length > 0) {
            this.auctionList = rows
          }
          this.auctionLoading = false
        }).catch(() => {
          this.auctionLoading = false
        })
      },
      // 获取成交公告列表（左侧）
      async getDealAnnouncementList() {
        this.loading = true
        try {
          const params = {
            pageNum: 1,
            pageSize: 10,
            dealDate: 'notNull', // 只查询已成交的公告
            announcementName: '',
            announcementNo: '',
            bidResultId: '',
            delFlag: '0',
            projectId: ''
          }
          
          const res = await getAnnouncementList(params)
          
          if (res.code === 200) {
            this.dealAnnouncementList = res.rows || []
          } else {
            console.error('获取成交公告失败:', res.msg)
            this.dealAnnouncementList = []
          }
        } catch (error) {
          console.error('获取成交公告异常:', error)
          this.dealAnnouncementList = []
        } finally {
          this.loading = false
        }
      },
      // 获取项目公告列表
      async getAnnouncementListData() {
        this.announcementLoading = true
        try {
          const params = {
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            searchValue: this.searchKeyword || ''
          }
          
          // 根据筛选条件添加参数
          // 公告类型 → sourceType
          if (this.type !== '全部') {
            params.sourceType = this.type === '正式挂牌' ? 'formal' : 'intention'
          }
          
          // 公告状态 → projectStatus
          if (this.status !== '全部') {
            const statusMap = {
              '挂牌中': 'listing',
              '报名中': 'applying',
              '竞价中': 'bidding',
              '已成交': 'dealed',
              '已终止': 'terminated'
            }
            params.projectStatus = statusMap[this.status]
          }
          
          // 项目分类 → projectType
          if (this.category !== '全部') {
            const categoryMap = {
              '转让': 'transfer',
              '许可': 'license',
              '作价入股': 'equity',
              '开放许可': 'open_license'
            }
            params.projectType = categoryMap[this.category] || this.category
          }
          
          const res = await getProjectHallList(params)
          
          if (res.code === 200) {
            this.announcementData = res.rows || []
            this.announcementTotal = res.total || 0
          } else {
            console.error('获取项目列表失败:', res.msg)
            this.announcementData = []
            this.announcementTotal = 0
          }
        } catch (error) {
          console.error('获取项目列表异常:', error)
          this.announcementData = []
          this.announcementTotal = 0
        } finally {
          this.announcementLoading = false
        }
      },
      // 搜索公告
      handleSearch() {
        this.currentPage = 1
        this.getAnnouncementListData()
      },
      injectMessageDialogStyles() {
        const style = document.createElement('style')
        style.textContent = `
          /* 消息弹窗 */
          .message-dialog .el-dialog {
            display: flex;
            flex-direction: column;
          }
          .message-dialog .el-dialog__header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
            padding: 24px 32px !important;
            border-radius: 16px 16px 0 0 !important;
            margin: 0 !important;
            flex-shrink: 0;
            position: relative;
            z-index: 10;
          }
          .message-dialog .el-dialog__title {
            font-size: 20px !important;
            font-weight: 600 !important;
            color: #FFFFFF !important;
            position: relative !important;
            display: inline-block !important;
            padding: 8px 20px !important;
            background: rgba(255, 255, 255, 0.2) !important;
            border-radius: 12px !important;
            border: 1px solid rgba(255, 255, 255, 0.3) !important;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
          }
          .message-dialog .el-dialog__headerbtn {
            background: rgba(255, 255, 255, 0.2) !important;
            position: absolute;
            top: 24px;
            right: 32px;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 11;
            transition: all 0.3s;
          }
          .message-dialog .el-dialog__headerbtn:hover {
            background: rgba(255, 255, 255, 0.3) !important;
            transform: scale(1.1);
          }
          .message-dialog .el-dialog__close {
            color: #FFFFFF !important;
            font-size: 18px !important;
            font-weight: bold !important;
            position: static;
            top: auto;
            right: auto;
          }
          .message-dialog .el-dialog__body {
            flex: 1;
            overflow-y: auto;
            padding: 32px;
            max-height: 600px;
          }
        `
        document.head.appendChild(style)
      },
      handlecurrweipai(e){
  console.log(e);
},
// 表颜色
tableRowClassName({rowIndex}) {

  console.log(rowIndex);
        if (rowIndex%2 ==0) {
          return 'warning-row';
        } else  {
          return 'success-row';
        }
        // return '';
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getAnnouncementListData()
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getAnnouncementListData()
        console.log(`当前页: ${val}`);
      },
      stripHtml(str = '') {
  return new DOMParser()
    .parseFromString(str, 'text/html')
    .body.textContent || '';
},
      getzjsjlist(e=1){
        this.loading = true
        let data = {
          pageNum:e,
          pageSize:10
        }
        getAction("/edu/demand/list", data).then(res => {
          this.listnum = res.total
          this.tableData = res.rows
          this.tableData.forEach(element => {
            element.demandDescription = this.stripHtml(element.demandDescription)
          });    
          this.loading = false
          console.log(res)
        })
      },
      tabchange(item){
        this.tabis = item
        this.getzjsjlist()
      },
      handleAnnouncementClick(item) {
        this.messageDetailData = item
        this.messageDialogVisible = true
      },
      handleMessageClick(item) {
        this.messageDetailData = item
        this.messageDialogVisible = true
      },
      handleMessageDialogClose() {
        this.messageDialogVisible = false
        this.messageDetailData = {}
      },
      goToDetail(item) {
        // 跳转到详情页，只传必要参数（id和sourceType），详情数据由接口获取
        this.$router.push({
          path: '/jydt-detail',
          query: {
            id: item.id,
            sourceType: item.sourceType
          }
        })
      },
      // 格式化价格
      formatPrice(price) {
        if (!price && price !== 0) return '面议'
        return `${price} 元`
      },
      // 格式化时间
      formatTime(time) {
        if (!time) return '--'
        return time.replace('T', ' ').slice(0, 19)
      },
      // 获取状态文本
      getStatusText(item) {
        const now = new Date().getTime()
        const startTime = item.listingStartTime ? new Date(item.listingStartTime).getTime() : 0
        const endTime = item.listingEndTime ? new Date(item.listingEndTime).getTime() : 0
        
        if (item.dealDate) {
          return '已成交'
        } else if (endTime && now > endTime) {
          return '已截止'
        } else if (startTime && now < startTime) {
          return '即将开始'
        } else if (startTime && endTime && now >= startTime && now <= endTime) {
          return '挂牌中'
        }
        return '进行中'
      },
      // 获取项目状态文本
      getProjectStatusText(status) {
        const statusMap = {
          'listing': '挂牌中',
          'applying': '报名中',
          'bidding': '竞价中',
          'dealed': '已成交',
          'terminated': '已终止'
        }
        return statusMap[status] || '未知状态'
      },
      // 获取项目类型文本
      getProjectTypeText(type) {
        const typeMap = {
          'transfer': '转让',
          'license': '许可',
          'equity': '作价入股',
          'open_license': '开放许可'
        }
        return typeMap[type] || type
      }
    }
  }
  </script>
  
  <style scoped>
/* 自定义弹窗样式 */
:deep(.message-dialog) {
  border-radius: 16px !important;
}

:deep(.message-dialog .el-dialog__header) {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  padding: 24px 32px !important;
  border-radius: 16px 16px 0 0 !important;
  margin: 0 !important;
}

:deep(.message-dialog .el-dialog__title) {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #FFFFFF !important;
  position: relative !important;
  display: inline-block !important;
  padding: 8px 20px !important;
  background: rgba(255, 255, 255, 0.2) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

:deep(.message-dialog .el-dialog__headerbtn) {
  width: 36px;
  height: 36px;
  top: 24px;
  right: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

:deep(.message-dialog .el-dialog__headerbtn:hover) {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

:deep(.message-dialog .el-dialog__headerbtn .el-dialog__close) {
  color: #FFFFFF;
  font-size: 18px;
  font-weight: bold;
  position: static;
  top: auto;
  right: auto;
}

:deep(.message-dialog .el-dialog__headerbtn:hover .el-dialog__close) {
  color: #FFFFFF;
}

:deep(.message-dialog .el-dialog__body) {
  padding: 32px;
  max-height: 600px;
  overflow-y: auto;
}

/* 详情内容样式 */
.dialog-content {
  width: 100%;
}

.detail-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  background: #F9FAFB;
  border-radius: 8px;
  border-left: 3px solid #3B82F6;
  transition: all 0.3s;
}

.detail-item:hover {
  background: #F3F4F6;
  border-left-color: #2563EB;
}

.detail-label {
  min-width: 100px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  flex-shrink: 0;
}

.detail-value {
  flex: 1;
  font-size: 14px;
  color: #6B7280;
  line-height: 1.6;
  word-break: break-word;
}

/* 滚动条样式 */
:deep(.el-dialog__body)::-webkit-scrollbar {
  width: 6px;
}

:deep(.el-dialog__body)::-webkit-scrollbar-track {
  background: #F3F4F6;
  border-radius: 3px;
}

:deep(.el-dialog__body)::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 3px;
}

:deep(.el-dialog__body)::-webkit-scrollbar-thumb:hover {
  background: #9CA3AF;
}

.content {
  width: 100%;
  min-height: calc(100vh - 196px);
  background: #F5F7FA;
  position: relative;
}

/* 顶部横幅 */
.banner-section {
  position: relative;
  width: 100%;
  height: 280px;
  overflow: hidden;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(10, 14, 26, 0.3) 0%, rgba(10, 14, 26, 0.6) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-text-wrapper {
  text-align: center;
}

.banner-subtitle {
  font-size: 14px;
  font-weight: 400;
  color: #51A2FF;
  letter-spacing: 2px;
  margin: 0 0 8px 0;
}

.banner-title {
  font-size: 36px;
  font-weight: 600;
  color: #FFFFFF;
  margin: 0;
  position: relative;
  padding-bottom: 20px;
}



/* 交易大厅区域 */
.trading-section {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
  background: #F5F7FA;
}

/* 主布局 */
.main-layout {
  width: 1200px;
  height: 313px;
  display: flex;
  gap: 32px;
}

/* 左侧区域 */
.left-section {
  flex: 1;
    height: 313px;
  background: #FFFFFF;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E5E7EB;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1F2937;
  margin: 0;
}

.messages-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
}

.messages-list::-webkit-scrollbar {
  width: 6px;
}

.messages-list::-webkit-scrollbar-track {
  background: #F3F4F6;
  border-radius: 3px;
}

.messages-list::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 3px;
}

.messages-list::-webkit-scrollbar-thumb:hover {
  background: #9CA3AF;
}

.no-data-small {
  text-align: center;
  padding: 40px 0;
  font-size: 14px;
  color: #9CA3AF;
}

.no-data {
  grid-column: 1 / -1;
  text-align: center;
  padding: 80px 0;
  font-size: 14px;
  color: #9CA3AF;
}

.message-item {
  display: flex;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #F3F4F6;
  cursor: pointer;
  transition: all 0.3s;
}

.message-item:last-child {
  border-bottom: none;
}

.message-item:hover {
  background: #F9FAFB;
  padding-left: 8px;
  padding-right: 8px;
  margin-left: -8px;
  margin-right: -8px;
  border-radius: 8px;
}

.message-dot {
  flex-shrink: 0;
  width: 5px;
  height: 5px;
  background: #3B82F6;
  border-radius: 50%;
  margin-top: 6px;
}

.message-content {
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.message-title {
  font-size: 13px;
  font-weight: 400;
  color: #374151;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.message-meta {
  display: flex;
  gap: 12px;
  font-size: 11px;
  color: #9CA3AF;
  flex-shrink: 0;
  margin-left: 16px;
}

.message-date,
.message-time {
  display: inline-block;
}

/* 右侧区域 */
.right-section {
  width: 280px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.service-module {
  width: 304px;
height: 143px;
  padding: 8px 14px;
  background: #FFFFFF;
  border-radius: 12px;
  text-align: center;
  transition: all 0.3s;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  text-decoration: none;
  display: block;
}

.service-module:hover {
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.15);
  transform: translateY(-4px);
}

.module-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
  background: #EFF6FF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.module-title {
  font-size: 18px;
  font-weight: 600;
  color: #1F2937;
  margin: 0 0 8px 0;
}

.module-subtitle {
  font-size: 13px;
  color: #9CA3AF;
  margin: 0;
}

/* 竞价会模块 */
.auction-section {
  width: 1200px;
  margin-top: 50px;
  background: #FFFFFF;
  border-radius: 12px;
  padding: 27px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.auction-header {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #E5E7EB;
}

.auction-table-wrapper {
  min-height: 80px;
}

/* 项目公告区域 */
.announcement-section {
  width: 1200px;
  margin-top: 30px;
  background: #FFFFFF;
  border-radius: 12px;
  padding: 27px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.announcement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #E5E7EB;
}

.announcement-title {
  font-size: 20px;
  font-weight: 600;
  color: #1F2937;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.action-btn {
  padding: 8px 20px;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  background: #FFFFFF;
  color: #6B7280;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.action-btn:hover {
  border-color: #3B82F6;
  color: #3B82F6;
}

.action-btn.primary {
  background: #3B82F6;
  color: #FFFFFF;
  border-color: #3B82F6;
}

.action-btn.primary:hover {
  background: #2563EB;
}

/* 筛选区域 */
.filter-section {
  margin-bottom: 24px;
}

.filter-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.filter-row:last-child {
  margin-bottom: 0;
}

.filter-label {
  font-size: 14px;
  color: #6B7280;
  margin-right: 16px;
  white-space: nowrap;
  min-width: 80px;
}

.filter-tags {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  flex: 1;
}

.filter-tag {
  padding: 6px 16px;
  background: #F3F4F6;
  border-radius: 6px;
  font-size: 14px;
  color: #6B7280;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

.filter-tag-active {
  background: #155DFC;
  color: #FFFFFF;
  border: 1px solid #155DFC;
}

.search-box {
  display: flex;
  gap: 8px;
  margin-left: auto;
}

.search-input {
  width: 200px;
  padding: 8px 12px;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: all 0.3s;
}

.search-input:focus {
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-btn {
  padding: 8px 20px;
  background: #3B82F6;
  color: #FFFFFF;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

.search-btn:hover {
  background: #2563EB;
}

/* 项目卡片列表 */
.projects-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 32px;
}

.project-card {
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
}

.project-card:hover {
  border-color: #3B82F6;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.15);
  transform: translateY(-4px);
}

.project-image {
  position: relative;
  width: 100%;
  height: 180px;
  background: #F3F4F6;
  overflow: hidden;
}

.project-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.placeholder-project-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F9FAFB;
}

.project-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 4px 12px;
  background: rgba(59, 130, 246, 0.9);
  color: #FFFFFF;
  font-size: 12px;
  border-radius: 4px;
  font-weight: 500;
}

.project-content {
  padding: 16px;
}

.project-title {
  font-size: 16px;
  font-weight: 600;
  color: #1F2937;
  margin: 0 0 12px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-row {
  display: flex;
  align-items: center;
  font-size: 13px;
}

.info-label {
  color: #9CA3AF;
  margin-right: 4px;
  white-space: nowrap;
}

.info-value {
  color: #6B7280;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.info-value.price {
  color: #EF4444;
  font-weight: 700;
  font-size: 15px;
}

.info-value.price {
  color: #EF4444;
  font-weight: 600;
  font-size: 14px;
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 24px;
  border-top: 1px solid #E5E7EB;
}

.pagination-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-info {
  font-size: 14px;
  color: #6B7280;
}

.pagination-detail {
  padding: 6px 16px;
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  color: #6B7280;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.pagination-detail:hover {
  border-color: #3B82F6;
  color: #3B82F6;
}

.custom-pagination {
  display: flex;
  justify-content: center;
}
  </style>
  
  